import styled from 'styled-components';

export const RewardPointContainerStyled = styled.div`
  .btn_create {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .w120 {
      margin-left: 8px;
      width: 120px;
    }
  }
  .body_table {
    margin-top: 20px;
    .body_status {
      display: flex;
      align-items: center;
      .round {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        flex-shrink: 0;
      }
      .label_status {
        margin-left: 6px;
      }
    }
  }
`;
